/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserAddressRequestUserAddress
 */
export interface CreateUserAddressRequestUserAddress {
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    prefectureId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    town: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    building?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserAddressRequestUserAddress
     */
    deliveryInstructions?: string;
}

/**
 * Check if a given object implements the CreateUserAddressRequestUserAddress interface.
 */
export function instanceOfCreateUserAddressRequestUserAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zipCode" in value;
    isInstance = isInstance && "prefectureId" in value;
    isInstance = isInstance && "city" in value;
    isInstance = isInstance && "town" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "phone" in value;

    return isInstance;
}

export function CreateUserAddressRequestUserAddressFromJSON(json: any): CreateUserAddressRequestUserAddress {
    return CreateUserAddressRequestUserAddressFromJSONTyped(json, false);
}

export function CreateUserAddressRequestUserAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserAddressRequestUserAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zipCode': json['zip_code'],
        'prefectureId': json['prefecture_id'],
        'city': json['city'],
        'town': json['town'],
        'street': json['street'],
        'building': !exists(json, 'building') ? undefined : json['building'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'phone': json['phone'],
        'deliveryInstructions': !exists(json, 'delivery_instructions') ? undefined : json['delivery_instructions'],
    };
}

export function CreateUserAddressRequestUserAddressToJSON(value?: CreateUserAddressRequestUserAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zip_code': value.zipCode,
        'prefecture_id': value.prefectureId,
        'city': value.city,
        'town': value.town,
        'street': value.street,
        'building': value.building,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'phone': value.phone,
        'delivery_instructions': value.deliveryInstructions,
    };
}

